import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { lazyAuth } from "@/lib/supabase-lazy";

export const Route = createFileRoute("/_authenticated")({
  ssr: false,
  beforeLoad: async () => {
    const { data, error } = await lazyAuth.getUser();
    // reloadDocument: en ren omladdning av startsidan i stället för att byta
    // sidträd mitt i hydreringen (som annars ger hydreringsvarningar).
    if (error || !data.user) throw redirect({ to: "/", reloadDocument: true });
    return { user: data.user };
  },
  component: () => <Outlet />,
});
